module.exports = __webpack_public_path__ + "img/angle-double-right-solid.3d0aa87e.svg";